// Wrapper de <input> con la convención de form-group / has-error /
// help-block que usaba el bundle legacy con Bootstrap 3. Mantenemos las
// clases por nombre para que en fase 1 podamos cargar reglas CSS
// equivalentes y reproducir el look del legacy. Sustituiremos las
// clases en fase 3 cuando rediseñemos.

import type { CSSProperties, FocusEvent, KeyboardEvent, RefCallback, ChangeEvent } from "react";
import type { KcDataMessagesPerField } from "../kcData";

export interface InputProps {
  id: string;
  type: string;
  name?: string;
  className?: string;
  placeholder?: string;
  defaultValue?: string;
  value?: string;
  autoComplete?: string;
  autoFocus?: boolean;
  readOnly?: boolean;
  helpText?: string;
  inputRef?: RefCallback<HTMLInputElement>;
  messagesPerField: KcDataMessagesPerField;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  onKeyPress?: (e: KeyboardEvent<HTMLInputElement>) => void;
  style?: CSSProperties;
  tabIndex?: number;
}

export function Input(props: InputProps) {
  const {
    id,
    helpText,
    messagesPerField,
    inputRef,
    className,
    ...rest
  } = props;
  const errorMessage =
    (messagesPerField as Record<string, string | undefined>)[id];
  const groupClass = `form-group ${errorMessage ? "has-error" : ""}`.trim();

  return (
    <div className={groupClass}>
      <input
        id={id}
        ref={inputRef}
        className={(className ?? "form-control")}
        {...rest}
      />
      {helpText ? (
        <div className="help-block">
          <div className="text-muted">{helpText}</div>
        </div>
      ) : null}
      {errorMessage ? (
        <p
          className="help-block"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      ) : null}
    </div>
  );
}
